/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const SolidArrowRight = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M8 8C8 7.17595 8.94076 6.70557 9.6 7.2L14.9333 11.2C15.4667 11.6 15.4667 12.4 14.9333 12.8L9.6 16.8C8.94076 17.2944 8 16.824 8 16V8Z"
                        fill={color}
                    />
                </svg>
        );
    };
